/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".fx_form_group .ant-form-item .ant-form-item-control-wrapper .ant-input-search-enter-button input{padding:0 30px 0 10px;border-radius:4px}"];
export { styles as styles };
